import React from 'react';
import InvoiceReportTab from '../components/InvoiceReportTab';

interface InvoiceReportPageProps {
  token: string;
}

const InvoiceReportPage: React.FC<InvoiceReportPageProps> = ({ token }) => {
  return <InvoiceReportTab />;
};

export default InvoiceReportPage;